import React, { FormEvent, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { useAdminAuth } from "../auth/AdminAuthProvider";
import { AdminTopHeader } from "../components/AdminTopHeader";

// 보호 라우트가 넘겨준 다음 경로를 그대로 복원해 로그인 후 이어서 진입한다.
function useNextPath() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  return params.get("next") || "/";
}

/**
 * 관리자 로그인 페이지.
 * Firebase Auth 로그인 후 next 쿼리 경로로 리다이렉트한다.
 */
export function LoginPage() {
  const { login, ready, user, error } = useAdminAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const next = useNextPath();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState("");
  const idleReason = new URLSearchParams(location.search).get("reason") === "idle";

  useEffect(() => {
    // 이미 인증된 사용자는 관리자 첫 화면으로 바로 보낸다.
    if (ready && user) {
      navigate(next, { replace: true });
    }
  }, [navigate, next, ready, user]);

  // 로그인 제출을 처리하고 성공 시 next 경로로 이동한다.
  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    setSubmitting(true);
    setMessage("");

    try {
      // 로그인 성공 여부는 Firebase Auth 온라인 인증 결과만 따른다.
      await login(email, password, remember);
      navigate(next, { replace: true });
    } catch (caught) {
      setMessage(caught instanceof Error ? caught.message : "로그인에 실패했습니다.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="cm-shell">
      <AdminTopHeader />
      <main className="cm-login-page">
        <form className="cm-login-card" onSubmit={handleSubmit}>
          <div className="cm-form-grid">
            <div className="cm-field">
              <label htmlFor="cm-email">Email</label>
              <input
                autoComplete="email"
                className="cm-input"
                disabled={submitting}
                id="cm-email"
                onChange={(event) => setEmail(event.target.value)}
                type="email"
                value={email}
              />
            </div>
            <div className="cm-field">
              <label htmlFor="cm-password">Password</label>
              <input
                autoComplete="current-password"
                className="cm-input"
                disabled={submitting}
                id="cm-password"
                onChange={(event) => setPassword(event.target.value)}
                type="password"
                value={password}
              />
            </div>
            <label className="cm-inline-row">
              <input checked={remember} onChange={(event) => setRemember(event.target.checked)} type="checkbox" />
              <span>이 기기에서 로그인 유지</span>
            </label>
            <button className="cm-btn" disabled={submitting || !ready} type="submit">
              {submitting ? "로그인 중..." : "로그인"}
            </button>
          </div>
          {message || error || idleReason ? (
            <div className="cm-notice error">{message || error || "30분 동안 동작이 없어 로그아웃되었습니다."}</div>
          ) : null}
        </form>
      </main>
    </div>
  );
}
